/*
 * @Description: 
 * @Author: ywj
 * @Date: 2023-04-06 09:33:52
 * @LastEditTime: 2024-12-13 14:54:24
 * @LastEditors: ywj@originqc.com
 */
import { Link } from 'react-router-dom';
import { assetsUrl } from '@/utils/assetsUrl';
import './footer-bottom.scss'

const policyPDF = `${assetsUrl}assets/files/pdf/%E9%9A%90%E7%A7%81%E6%94%BF%E7%AD%96.pdf`;
const servicePDF=`${assetsUrl}assets/files/pdf/用户信息服务条款.pdf`


const FooterBottom = () => {
  const openFile = () => {
      window.open(policyPDF);
  };
  const openFileService = () => {
      window.open(servicePDF);
    
  };
  return (
    <div className='footerBottom'>
      <div
        className={'footerBottomBox'}
      >
        <span>Copyright © 2017 - {new Date().getFullYear()} Origin Quantum. All Rights Reserved. 本源量子版权所有</span>
        <span className="line">|</span>
        {/* <Link onClick={()=>window.scrollTo({top:0})} to='/copyrightWord' className='bq_color'>
          {t('copyRight')}
        </Link> */}
        {/* <span className="line">|</span> */}
        <a
          href='https://beian.miit.gov.cn/'
          target='_blank'
          rel='noopener noreferrer'
        >
          皖ICP备 17025557号-1
        </a>
        <span className="line">|</span>
        <span>皖公网安备 34011102000802号</span>
        <span className="line">|</span>
        <span className='privacy-text' onClick={openFileService}>
        《服务协议》
        </span>
        <span className="line">|</span>
        <span className='privacy-text' onClick={openFile}>
        《隐私政策》
        </span>
      </div>
    </div>
  )
}
export default FooterBottom